module.exports = __webpack_public_path__ + "img/icon_ipo_suggestion_3@2x.69137ea6.png";